export default __webpack_public_path__ + "static/15_33-292b6b817e49354d52db47f577701ccf.png";